import { useCallback, useEffect } from 'react'
import { CUSTOM_EVENT_NAME, DrawerEvent, DrawerEventType } from '@typesApp/AppEvent'
import { useOpenDrawer } from '@hooks/useOpenDrawer'

export const useDrawerEventListener = () => {
  const { openDrawer } = useOpenDrawer()

  const eventListener = useCallback(
    (event: Event) => {
      if (!isCustomEvent(event)) return

      const eventHandlers = {
        onOpenDrawer: event => event.type === 'onOpenDrawer' && openDrawer(event.payload),
      } as Record<DrawerEventType, (event: DrawerEvent) => void>

      const drawerEvent = event?.detail
      if (drawerEvent?.type) {
        eventHandlers[drawerEvent.type]?.(drawerEvent)
      }
    },
    [openDrawer]
  )

  useEffect(() => {
    document.addEventListener(CUSTOM_EVENT_NAME.DRAWER, eventListener)
    return () => {
      document.removeEventListener(CUSTOM_EVENT_NAME.DRAWER, eventListener)
    }
  }, [eventListener])
}

const isCustomEvent = (event: Event): event is CustomEvent<DrawerEvent> => {
  return event instanceof CustomEvent
}
